export const isQaEnv = () => window.location.hostname.toLowerCase().indexOf('zeus.fds.com') > -1;

export const isAnyOfTouchEvent = (event) => ['touchstart', 'touchmove', 'touchend', 'touchcancel'].includes(event.type);

export const clamp = (n, min, max) => Math.max(Math.min(n, max), min);

export const isString = (str) => typeof str === 'string' || str instanceof String;
